import { ControlPointOutlined, Search } from "@mui/icons-material";
import { Button, TextField, Tooltip, InputAdornment } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import BulkCreateAppointment from "../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/BulkCreateAppointment";
import { useDebounce } from "../../../hooks/useDebounce";
import useMedicalCompleteLock from "../../../hooks/useMedicalCompleteLock";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { MEDICALLY_COMPLETE_LOCK_MESSAGE } from "../ClientDetail/Case/utils/constants";

const TopMenu = ({ caseInfo }) => {
  const [openAddAppts, setOpenAddAppts] = useState(false);
  const { isAppointmentLocked } = useMedicalCompleteLock();
  const appointmentLocked = isAppointmentLocked(caseInfo);
  const { filters, updateFilter } = useQueryParams();
  const [search, setSearch] = useState(filters.get("apptSearch") || "");
  const debouncedSearch = useDebounce(search, 500);
  const userEditedRef = useRef(false);

  const handleAddAppointment = () => {
    setOpenAddAppts(!openAddAppts);
  };

  useEffect(() => {
    updateFilter(
      "apptSearch",
      debouncedSearch || undefined,
      null,
      !userEditedRef.current
    );
  }, [debouncedSearch]);

  return (
    <div className="flex justify-between w-full">
      <div className="flex items-center w-1/2 mt-4 xl:h-1/6">
        <TextField
          className="w-full mx-4 mr-4 rounded-lg placeholder:text-center"
          placeholder="Search"
          size="small"
          value={search}
          onChange={(event) => {
            userEditedRef.current = true;
            setSearch(event.target.value);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="outlined"
          size="medium"
          color="error"
          onClick={() => {
            userEditedRef.current = true;
            setSearch("");
          }}
          className="mr-4 rounded-md w-1/8 hover:bg-red-500 hover:text-white"
        >
          Reset
        </Button>
      </div>
      <div className="flex items-center">
        <Tooltip
          title={appointmentLocked ? MEDICALLY_COMPLETE_LOCK_MESSAGE : "Add Appointment"}
          placement="left"
        >
          <Button
            className="self-center text-[#32CD30] hover:bg-green-500 hover:text-white"
            disabled={appointmentLocked}
            onClick={handleAddAppointment}
          >
            <span className="mx-4">
              <ControlPointOutlined />
            </span>
          </Button>
        </Tooltip>
      </div>
      {openAddAppts && (
        <BulkCreateAppointment
          open
          onClose={() => setOpenAddAppts(false)}
          title="Create Appointments"
          setOpenAddAppts={setOpenAddAppts}
          caseInfo={caseInfo}
        />
      )}
    </div>
  );
};

export default TopMenu;
